const headers = {
  name: "Blogs",
  navigate: {
    path: [
      {
        name: "Blogs",
        path: "/app/blogs",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
